import { render } from "./PrintPreview.vue?vue&type=template&id=88da6ddc&scoped=true"
import script from "./PrintPreview.vue?vue&type=script&lang=js"
export * from "./PrintPreview.vue?vue&type=script&lang=js"

import "./PrintPreview.vue?vue&type=style&index=0&id=88da6ddc&scoped=true&lang=css"
import "./PrintPreview.vue?vue&type=style&index=1&id=88da6ddc&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88da6ddc"]])

export default __exports__